import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';
import apiClient from '../../../utils/apiClient';

import './User.css'

import UserMailModal from './Modal/UserMailModal'
import { useTranslation } from "react-i18next";

const User = () => {
  const { t } = useTranslation();

  const [offset, setOffset] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [order, setOrder] = React.useState('id');
  const [desc, setDesc] = React.useState(0);
  const [userList, setUserList] = React.useState([]);
  const [isRestricted, setIsRestricted] = React.useState(false);
  const [restrictionMessage, setRestrictionMessage] = React.useState('');

  const [search, setSearch] = React.useState('');
  const [userInfo, setUserInfo] = useState({})

  useEffect(() => {
    if (userInfo.id) {
      return;
    }

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    const api = async () => {
      try {
        const queryParams = `offset=${offset}&keyword=${search}&order=${order}&desc=${desc}`;
        const response = await apiClient.fetchUsers(queryParams);
        
        if (response && response.users) {
          // データが配列であることを確認してからセット
          const users = Array.isArray(response.users) ? response.users : [];
          setUserList(users);
          setTotal(response.total || 0);
          
          // WAF制限状態の表示
          if (response.personal_info_restricted) {
            setIsRestricted(true);
            setRestrictionMessage(response.message || '個人情報の表示が制限されています');
            console.log('個人情報表示が制限されています:', response.message);
          } else {
            setIsRestricted(false);
            setRestrictionMessage('');
          }
        } else {
          setUserList([]);
          setTotal(0);
        }
      } catch (error) {
        console.error('ユーザー一覧取得エラー:', error);
        setUserList([]);
        setTotal(0);
      }
    }
    
    if (search == '') {
      api();
    } else {
      const timer = setTimeout(() => {
        api();
      }, 500)
  
      return () => clearTimeout(timer)
    }
  }, [offset, search, userInfo.id, order, desc])


  const changeOffset = (offset) => {
    if (offset < 0) {
      offset = 0;
    }
    if (offset > total) {
      offset = Math.floor(total / 100) * 100;
    }
    setOffset(offset);
  }

  const CreateUserHistoryList = () => {
    // userListが未定義または配列でない場合は空配列として扱う
    const safeUserList = Array.isArray(userList) ? userList : [];
    
    return safeUserList.map((user, index) => {
      return <Tr key={index} user={user} userMailHandler={userMailHandler}/>
    })
  }

  const [userMailModalIsOpen, setUserMailModalIsOpen] = useState(false)

  const userMailHandler = (id, email) => {
    setUserInfo({id: id, email: email})
    setUserMailModalIsOpen(true)
  }

  const closeAndResetModal = () => {
    setUserMailModalIsOpen(false)
  }

  return (
    <>
      <Header />
      <SideMenu />
      <div className="user-list">
        {isRestricted && (
          <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm">
                  <strong>アクセス制限中:</strong> {restrictionMessage}
                </p>
                <p className="text-xs mt-1">
                  個人名情報は「***」で表示されます。IDとメールアドレスでの検索のみ利用可能です。
                </p>
              </div>
            </div>
          </div>
        )}
        <div className="user-list-title">{t('user.title')}</div>
        <div className='clearfix'></div>
        <div className="user-list-search">
          <table className="user-list-search-table">
            <tbody>
              <tr>
                <td>
                  <input className="user-list-search-input" type="text" placeholder={t('user.placeholder')} value={search} onChange={(e) => {setSearch(e.target.value);setOffset(0)}} />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="user-list-search-paging">
            <button className="user-list-search-paging-prev-button user-list-search-paging-button" onClick={() => changeOffset(offset - 100)}>{t('user.prev')}</button>
            <div className="user-list-search-paging-text">{offset + 1} - {offset + 100 > total ? total : offset + 100} / {total}</div>
            <button className="user-list-search-paging-next-button user-list-search-paging-button" onClick={() => changeOffset(offset + 100)}>{t('user.next')}</button>
          </div>
        </div>
        <div className="user-list-content">
          <div className="user-list-content-table">
            <table className="user-list-content-table">
              <thead>
                <tr>
                  <th className='sortable' onClick={() => {setOrder('id');setDesc(desc == 0 ? 1 : 0)}}>
                    {order == 'id' ? (desc == 0 ? '▲' + t('user.user') : '▼' + t('user.user')) : t('user.user')}
                  </th>
                  <th>{t('user.email')}</th>
                  <th>{t('user.name')}</th>
                  <th>{t('user.identity')}</th>
                  <th>{t('user.identity_verified_at')}</th>
                  <th className='sortable' onClick={() => {setOrder('point');setDesc(desc == 0 ? 1 : 0)}}>
                    {order == 'point' ? (desc == 0 ? '▲' + t('user.hold') : '▼' + t('user.hold')) : t('user.hold')}
                  </th>
                  <th className='sortable' onClick={() => {setOrder('total_payment_amount');setDesc(desc == 0 ? 1 : 0)}}>
                    {order == 'total_payment_amount' ? (desc == 0 ? '▲' + t('user.total') : '▼' + t('user.total')) : t('user.total')}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <CreateUserHistoryList />
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <UserMailModal userMailModalIsOpen={userMailModalIsOpen} closeAndResetModal={closeAndResetModal} userInfo={userInfo} setUserInfo={setUserInfo}/>
    </>
  )
}

export default User